import React from 'react';
import '../apps.scss';
import { useStores } from '../../../store';
import useCustomModal from '../../../shared/custom-modal/custom-modal';
import usePromiseFeedback from '../../../shared/promise-feedback/usePromiseFeedback';
import { AppWithStatus } from '../../../../dtos/app.dto';
import managedAppsService from '../../../../services/managed-apps.service';
import { toastSuccessUpdateManageApp } from '../apps-utils';
import { RuleHelper } from 'src/utils/rule-helper';

interface RemoveAppActionProps<AppWithStatus> {
    managedApps: AppWithStatus[];
    app: AppWithStatus;
    isDisabled?: boolean;
}
export const RemoveAppAction = (props: RemoveAppActionProps<AppWithStatus>) => {
    const { fwVersionStore } = useStores();
    const [showModal, , contextHolder] = useCustomModal();
    const [promiseFeedbackFactory, promiseContextHolder] = usePromiseFeedback();
    const { managedApps, app, isDisabled } = props;
    const { id, displayName } = app;

    const onAppRemove = () => {
        const inboundApps: string[] = RuleHelper.collectAllowedDependentApps(app, managedApps, 'inboundAllowed').map(_ => _.displayName);
        const outboundApps: string[] = RuleHelper.collectAllowedDependentApps(app, managedApps, 'outboundAllowed').map(_ => _.displayName);
        const dependentApps: string[] = Array.from(new Set([...inboundApps, ...outboundApps]));

        if (dependentApps.length > 0) {
            showRemoveModal('no-support-modal-wrapper', displayName,
                <>
                    <div className="modal-commit-message">
                        {displayName} will be removed from your managed apps list  and the configuration will be changed to default.
                    </div>
                    <div className="modal-commit-message">
                        The following allowed apps are dependent on {displayName} and therefore might no longer be accessible if the default behavior is block:
                    </div>
                    <span className="modal-small-commit-message">{
                        dependentApps.map(app =>
                            <span key={id} className="dependent-app">{app}</span>)}
                    </span>
                </>);
        } else {
            showRemoveModal('remove-app-modal-wrapper', displayName,
                <div className="modal-commit-message">
                    {displayName} will be removed from your managed apps list and the configuration will be changed to default behavior.
                </div>);
        }
    };

    const showRemoveModal = (wrapClassName: string, appName: string, children: React.ReactElement) => {
        showModal({
            wrapClassName: wrapClassName,
            width: 618,
            title: `Remove ${appName}?`,
            body: () => children,
            okText: 'Remove',
            cancelText: 'Cancel',
            onOk: () => promiseFeedbackFactory({
                promise: fwVersionStore.genericCrudMethod(managedAppsService.removeManageApp, [id]),
                successCallback: () => toastSuccessUpdateManageApp(),
                notifObj: { show: false }
            }),
            closable: true
        });
    };

    return <>
        <button type="button" className={`button-wrapper text remove-button ${isDisabled ? 'disabled' : ''}`}
              data-testid="app-remove" onClick={onAppRemove}>
            Remove
        </button>
        {contextHolder}
        {promiseContextHolder}
    </>;
};